import { BiSignal } from "@faire/web-api--source/indigofair/data/BiSignal";

export const getSearchPageLoadKey = (options: {
  query: string;
  filters: string[];
  pageNumber: number;
  doQuerySpellCheck: boolean;
  noBrandsOffFaireQuery: boolean;
  bis?: keyof typeof BiSignal;
}) => {
  const {
    query,
    filters,
    pageNumber,
    doQuerySpellCheck,
    noBrandsOffFaireQuery,
    bis,
  } = options;
  return `${query}-${filters}-${pageNumber}-${doQuerySpellCheck}-${noBrandsOffFaireQuery}-${bis ?? ""}`;
};
